<template>
  <div class="content-wrap">
    <Form :bodyClass="''" :title="titleText" @submit="submitBaseData">
      <FormInput
        v-model="formData.email"
        :name="$t('user.email')"
        type="email"
        required
        :disabled="templateMode === 'edit'"
      />
      <div class="two-columns">
        <FormInput v-model="formData.first_name" :name="$t('user.firstName')" labelOptional />
        <FormInput v-model="formData.last_name" :name="$t('user.lastName')" labelOptional />
      </div>
      <FormInput
        v-if="templateMode == 'edit' && !withRoles"
        v-model="formData.password"
        :name="$t('user.changePassword')"
        type="password"
        labelOptional
      />
      <FormSelect
        v-if="!withRoles"
        v-model="formData.language"
        :name="$t('meta.language')"
        :options="supportedLocales"
      />

      <FormSelect
        v-if="withRoles"
        v-model="formData.roles"
        :name="$t('user.companyUserRole')"
        :options="validRoleOptions"
        multiple
      />

      <p v-if="templateMode == 'add'" class="alert alert-info">{{ $t('user.passwordMailNotice') }}</p>
      <Button type="submit" :disabled="submitDisabled" fullWidth>{{ $t('meta.save') }}</Button>
    </Form>
  </div>
</template>
<script>
import Button from '@/components/Button/index.vue'
import FormInput from '@/components/Form/Input/index.vue'
import FormSelect from '@/components/Form/Select/index.vue'
import Form from '@/components/Form/index.vue'

import companiesApi from '@/api/companies'
import configApi from '@/api/config'
import { availableLocales } from '@/i18n'
import { roleOptions, validRoles } from '@/utils/roles'

export default {
  name: 'UserBaseData',
  components: {
    Button,
    Form,
    FormInput,
    FormSelect,
  },
  props: {
    onSubmitBaseData: { type: Function, required: true },
    templateMode: { type: String, required: true, validator: value => ['edit', 'add'].includes(value) },
    title: { type: String, required: false },
    user: { type: Object, required: true },
  },
  data() {
    return {
      company: null,
      config: null,
      formData: {
        email: null,
        first_name: null,
        last_name: null,
        language: null,
        password: null,
        roles: null,
      },
    }
  },
  watch: {
    user: {
      immediate: true,
      handler() {
        this.prefillExistingValues()
      },
      deep: true,
    },
  },
  computed: {
    supportedLocales() {
      return availableLocales.map(locale => ({
        label: this.$t(`meta.locale.${locale}`),
        value: locale,
      }))
    },
    submitDisabled() {
      return this.templateMode == 'add' && !this.formData.email
    },
    titleText() {
      return this.title || this.$t('meta.baseData')
    },
    withRoles() {
      return !!this.user.roles
    },
    validRoleOptions() {
      if (!this.company || !this.config) return
      return roleOptions(validRoles(this.company, this.config))
    },
  },
  methods: {
    async submitBaseData() {
      this.onSubmitBaseData(this.formData)
    },
    prefillExistingValues() {
      if (this.user.roles) {
        this.formData.email = this.user.user.email
        this.formData.first_name = this.user.user.first_name
        this.formData.last_name = this.user.user.last_name
        this.formData.roles = this.user.roles
      } else {
        this.formData.email = this.user.email
        this.formData.first_name = this.user.first_name
        this.formData.language = this.user.language
        this.formData.last_name = this.user.last_name
      }
    },
  },
  async created() {
    if (this.user.company_uuid) {
      this.config = await configApi.get()
      this.company = await companiesApi.get(this.user.company_uuid)
    }
    this.prefillExistingValues()
  },
}
</script>
